((name, context, definition) ->
	context[name] = definition()
)('random', this, () ->
	class R
		constructor: (min, max) ->
			@rand = min + Math.random() * (max + 1 - min)
			@rand = Math.floor(@rand)
	random = (min=Number.MIN_SAFE_INTEGER,max=Number.MAX_SAFE_INTEGER) ->
		return new R(min,max).rand
	return random
)
do ->
	mjs = if 'ontouchstart' of window then true else false
	class Modal
		constructor: (title, content, classes, btn, callback=() ->
			return
		) ->
			@callback = callback
			@title = title
			@content = content
			@classes = classes
			@id = ''
			@btn = btn
			return

		create: () ->
			@bg = $('<div>',{class:'modal-bg'})
			@id = 'modal_'+random(0)
			m = $('<div>',{id:@id,class:'modal '+@classes})
			mhead = $('<div>',{class:'modal-header'}).html('<button type="button" class="close" data-dismiss="modal">&times;</button><h3>'+@title+'</h3>')
			mbody = $('<div>',{class:'modal-body'}).append(@content)
			mfter = $('<div>',{class:'modal-footer'})
			if @btn.length > 0
				for b in @btn
					mfter.append(b)
			mc = $('<div>',{class:'modal-content'})
			mc.append mhead
			mc.append mbody
			mc.append mfter
			m.append mc
			$('body').append @bg
			$('body').append m
			rm = @
			closers = m.find('[data-dismiss="modal"]')
			@bg.on 'click', () ->
				rm.remove()
			closers.on 'click', () ->
				rm.remove()
			m.on 'DOMNodeRemoved', () ->
				if event.target.id == rm.id
					closers.off 'click'
			return

		show: () ->
			e = $('#'+@id)
			a = @
			if e.length > 0
				setTimeout () ->
					a.bg.addClass('in')
					e.addClass('in')
					a.callback.call()
				, 10
			return

		remove: () ->
			e = $('#'+@id)
			a = @
			if e.length > 0
				for btn in @btn
					btn.off 'click'
				@bg.removeClass('in')
				e.removeClass('in')
				setTimeout () ->
					a.bg.remove()
					e.remove()
				, 800
			return

	class Lightbox
		constructor: (source) ->
			if (source.tagName).toLowerCase() == 'img'
				@source = $(source)
			else
				@source = $(source).find('img')
			@bg = $('<div>',{class:'lightbox-background'})
			@box = $('<div>',{id:random(0),class:'lightbox-popup'})
			@close_but = $('<button>',{class:'close'}).html('&times;')
			@preloader = $('<div>',{class:'preloader'}).html('<svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="8"/></svg>')
			@image = $('<img>',{class:'hidden'})
			src = @source.data('srcset') || @source.attr('src')
			src = src.split(', ')
			temp = []
			for i in src
				k = i.split(' ')
				if k[1] == undefined
					temp[parseInt(1)] = k[0]
				else
					temp[parseInt(k[1])] = k[0]
			@src = temp[temp.length - 1]
			LB = @
			@image.on 'load', (e) ->
				LB.finish()
			@close_but.on 'click', () ->
				LB.close()
			@bg.on 'click', () ->
				LB.close()
			@image.attr('src',@src)
			@box.append(@close_but).append(@preloader).append(@image)
			@create()
			return @
		create: () ->
			$('body').append(@bg)
			$('body').append(@box)
			LB = @
			setTimeout ()->
				LB.bg.addClass('show')
				LB.box.addClass('show')
			, 1
			return @
		finish: () ->
			mh = Math.max(document.documentElement.clientHeight, window.innerHeight) * 0.9
			mw = Math.max(document.documentElement.clientWidth, window.innerWidth) * 0.9
			iw = @image[0].naturalWidth
			ih = @image[0].naturalHeight
			tw = 0
			th = 0
			if iw<mw and ih<mh
				tw = iw
				th = ih
			else
				c = iw/ih
				mc = mw/mh
				if mc > c
					tw = c * mh
					th = mh
				else
					tw = mw
					th = mw / c
			@box.css({'width':tw+'px','height':th+'px'})
			@box.toggleClass('show active')
			@preloader.remove()
			@image.removeClass('hidden')
		close: () ->
			@box.removeClass('active show')
			@bg.removeClass('show')
			LB = @
			setTimeout ()->
				LB.bg.remove()
				LB.box.remove()
			, 400

	lightbox = (source) ->
		return new Lightbox(source)

	class extSlider
		constructor: (container) ->
			@container = container
			if @container.length > 0
				eS = @
				@in_action = false
				@controls = @container.find('.controls')
				@img_container = @container.find('.images')
				images = @img_container.find('.image')
				@images = []
				@button_prev = $('<button>',{class:'prev'})
				@controls.append(@button_prev)
				@indicators = []
				images.each (index,el) ->
					indicator = $('<span>',{data:{'num':index+''}})
					img = $(el).data('num',index+'')
					eS.controls.append(indicator)
					eS.indicators.push(indicator)
					eS.images.push(img)
				@button_next = $('<button>',{class:'next'})
				@controls.append(@button_next)
				@counts = @images.length - 1
				@indicators.forEach (ind) ->
					ind.on 'click', () ->
						eS.query(this.dataset.num)
				@index = 0
				vis1 = @index + 0
				vis2 = @index + 1
				vis3 = @index + 2
				if vis1 > @counts
					vis1 = vis1 - @counts
				if vis2 > @counts
					vis2 = vis2 - @counts
				if vis3 > @counts
					vis3 = vis3 - @counts
				@images[vis1].addClass('visible')
				@images[vis2].addClass('visible')
				@images[vis3].addClass('visible')
				@indicators[@index].addClass('active')
				@delay = 450
				if @counts <= @ecps
					@button_next.addClass('disabled')
					@button_prev.addClass('disabled')
				else
					@button_next.removeClass('disabled')
					@button_prev.removeClass('disabled')
				@button_next.on 'click', ()->
					eS.next()
				@button_prev.on 'click', ()->
					eS.prev()
				return @
			else
				return false
		next: () ->
			if !@in_action
				eS = @
				@in_action = true
				cur = @index
				next = cur + 1
				if next > @counts
					next = 0
				vis1 = next + 0
				vis2 = next + 1
				vis3 = next + 2
				if vis1 > @counts
					vis1 = vis1 - @counts - 1
				if vis2 > @counts
					vis2 = vis2 - @counts - 1
				if vis3 > @counts
					vis3 = vis3 - @counts - 1
				@images[cur].addClass('hidden')
				@images.forEach (img) ->
					img.removeClass('visible')
				@images[vis1].addClass('visible')
				@images[vis2].addClass('visible')
				@images[vis3].addClass('visible')
				@indicators.forEach (indicator) ->
					indicator.removeClass('active')
				@indicators[next].addClass('active')
				setTimeout () ->
					eS.img_container.append(eS.images[cur])
					eS.images[cur].removeClass('hidden')
					eS.index = next
					eS.in_action = false
				, @delay
		prev: () ->
			if !@in_action
				eS = @
				@in_action = true
				cur = @index
				prev = cur - 1
				if prev < 0
					prev = @counts
				vis1 = prev + 0
				vis2 = prev + 1
				vis3 = prev + 2
				if vis1 > @counts
					vis1 = vis1 - @counts - 1
				if vis2 > @counts
					vis2 = vis2 - @counts - 1
				if vis3 > @counts
					vis3 = vis3 - @counts - 1
				@images[prev].addClass('hidden')
				@img_container.prepend(@images[prev])
				@images.forEach (img) ->
					img.removeClass('visible')
				@images[vis1].addClass('visible')
				@images[vis2].addClass('visible')
				@images[vis3].addClass('visible')
				@indicators.forEach (indicator) ->
					indicator.removeClass('active')
				@indicators[prev].addClass('active')
				setTimeout () ->
					eS.images[prev].removeClass('hidden')
				, 10
				setTimeout () ->
					eS.index = prev
					eS.in_action = false
				, @delay
		query: (num) ->
			console.log 'quered', num
			cur = @index
			eS = @
			if num > cur
				dia = num - cur
				console.log 'next', dia
				for i in [0...dia]
					setTimeout () ->
						eS.next()
					, (eS.delay+20) * i
			else if num < cur
				dia = cur - num
				console.log 'prev', dia
				for i in [0...dia]
					setTimeout () ->
						eS.prev()
					, (eS.delay+20) * i
			return

	Serialize = (target) ->
		data = {}
		for_len_check = {}
		error_obj = null
		len_error_obj = null
		all = true
		len_all = true
		target.find('input, textarea').each (index,input) ->
			if input.value != ''
				if input.getAttribute('type') == 'checkbox'
					if input.checked == true
						if data[input.name] == undefined
							data[input.name] = Array()
						data[input.name].push input.value
					else
						if input.getAttribute('data-minlen') != null
							for_len_check[input.name] = [input,parseInt(input.getAttribute('data-minlen'))]
				else if input.getAttribute('type') == 'radio'
						if input.checked == true
							data[input.name] = input.value
				else
					data[input.name] = input.value
			else
				if input.getAttribute('required') != null
					if error_obj == null
						error_obj = input
					all = false
		if Object.keys(for_len_check).length > 0
			for input of for_len_check
				if input not of data
					len_all = false
					len_error_obj = for_len_check[input][0]
				else if data[input].length < for_len_check[input][1]
					len_all = false
					len_error_obj = for_len_check[input][0]
		return {status:all, len_status:len_all, data:data, error:error_obj, len_error:len_error_obj}

	sendRequest = (target) ->
		event.preventDefault();
		data = {}
		all = true
		res = Serialize(target)
		if res.status == true
			res.data['formsubmit'] = true
			$.post('/request.php', res.data, (resp)->
				if resp == 'true'
					c = new Modal 'Ваш запрос отправлен', '', '', []
					c.create()
					c.show()
					$('#'+c.id).addClass('sent')
					target.find('input:not(.hidden)').each (ind,inp) ->
						inp.value = ''
				else
					c = new Modal 'Вы заполнили не все поля', '', '', []
					c.create()
					c.show()
					$('#'+c.id).addClass('sent')
			)
		else
			er = $(res.error).addClass('error')
			c = new Modal 'Вы заполнили не все поля', '', '', []
			c.create()
			c.show()
			$('#'+c.id).addClass('sent')

	openOrder = () ->
		content = $('<div class="form"><input type="hidden" name="type" value="order"><input type="text" name="name" placeholder="Имя*" required><input type="text" name="surname" placeholder="Фамилия"><input type="text" name="phone" placeholder="Телефон*" required></div>')
		button = $('<button type="button" data-action="send">Отправить</button>')
		c = new Modal 'Заказать КИВ', content, '', [button]
		c.create()
		c.show()
		$(button).on 'click', () ->
			sendRequest(content)

	load_entries = () ->
		current_count = $('.gallery .image:not(.grid-filler)').length
		$.post(window.location.pathname, {'offset':current_count}, (data) ->
			if data != ''
				$('.gallery .image.grid-filler').remove()
				$('.gallery .images').append(data)
				init_lightbox()
		)

	init_lightbox = () ->
		$('[data-action="lightbox"]').off 'click'
		$('[data-action="lightbox"]').on 'click', () ->
			lightbox(this)

	window.initMap = () ->
		coord = {}
		for c of window.mapCoord
			if window.mapCoord[c] != 'false'
				p = window.mapCoord[c].split(/\s*,\s*/)
				coord[c] = [parseFloat(p[0]),parseFloat(p[1])]
			else
				coord[c] = 'false'
		$('#RaI').remove()
		map = new Hate.Map('map', {center: coord['vor'], zoom: 11})
		map.behaviors.disable('scrollZoom')
		for c of coord
			marker = new Hate.Placemark(coord[c])
			map.geoObjects.add(marker)
		togglers = $('[data-toggle]')
		tog = (e) ->
			nc = $(e).data('toggle')
			if coord[nc] != 'false' and coord[nc] != undefined
				togglers.removeClass('active')
				$(e).addClass('active')
				map.panTo(coord[nc],{fluing: 0, speed: 1})
		togglers.on 'mouseenter', () ->
			tog(this)
		togglers.on 'touchstart', () ->
			tog(this)

	init = ->
		$('[data-action="ische"]').on 'click', () ->
			load_entries()
		$('[data-action="send"]').on 'click', () ->
			target = $(this).parent()
			sendRequest(target)
		$('[data-action="order"]').on 'click', () ->
			openOrder()
		init_lightbox()
		sl = $('.slider')
		if sl.length > 0
			window.eSL = new extSlider(sl)
		
		if(!mjs)
			links = $('a[href^="tel"]')
			links.each (index,link) ->
				link.href = link.href.replace(/tel/,"callto")
		return
	window.onload = () ->
		init()